export default __webpack_public_path__ + "static/media/Akash.74848bc3.jpg";